import {
  GlobalCompanyTabID,
  GlobalCompanyTabNanoID,
  GlobalCompanyTabUUID,
  DeleteGlobalCompanyTabCacheKeys,
  DeleteGlobalCompanyTabGqlQuery
} from '../../globalCompanyTabsTypes';

import { useEdDeleteQuery } from '../../../common/reactQuery/hooks/useEdDeleteQuery';
import { ErrorType } from '../../../../utils/parseRequestError';

interface DeleteGlobalCompanyTabOptions {
  query: DeleteGlobalCompanyTabGqlQuery;
  cacheKeys?: DeleteGlobalCompanyTabCacheKeys;
}

export interface DeleteGlobalCompanyTabInput {
  uid: GlobalCompanyTabUUID | GlobalCompanyTabNanoID | GlobalCompanyTabID;
}

export type DeleteGlobalCompanyTabError = ErrorType;

const action = 'deleteGlobalCompanyTab';

function useDeleteGlobalCompanyTab({
  query,
  cacheKeys
}: DeleteGlobalCompanyTabOptions) {
  const {
    deleteQuery,
    deleteQueryData,
    deleteQueryError,
    deleteQueryErrorMessage,
    deleteQueryLoading,
    deleteQueryReset
  } = useEdDeleteQuery<
    DeleteGlobalCompanyTabInput,
    DeleteGlobalCompanyTabInput,
    DeleteGlobalCompanyTabError
  >({ action, query, cacheKeys });

  return {
    deleteGlobalCompanyTab: deleteQuery,
    deleteGlobalCompanyTabData: deleteQueryData,
    deleteGlobalCompanyTabError: deleteQueryError,
    deleteGlobalCompanyTabErrorMessage: deleteQueryErrorMessage,
    deleteGlobalCompanyTabLoading: deleteQueryLoading,
    deleteGlobalCompanyTabReset: deleteQueryReset
  };
}

export default useDeleteGlobalCompanyTab;
